import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

const KEY = "heylpmate_theme";

export default function ThemeToggle() {
  const [theme, setTheme] = useState(() => {
    if (typeof window === "undefined") return "light";
    return localStorage.getItem(KEY) || "light";
  });

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem(KEY, theme);
  }, [theme]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label="Toggle dark mode"
      className="inline-flex items-center justify-center w-9 h-9 rounded-full border transition"
      style={{ borderColor: "var(--border)", background: "var(--surface)", color: "var(--text-main)" }}
    >
      {theme === "dark" ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  );
}
